import { getRecoil, setRecoil } from 'recoil-nexus';

import { enhanceNoteLoadingState } from 'components/practice/charts/ClinicalNote/MyScribeAI/state';
import state from 'components/state';

export default (data) => {
  if (data?.promptKind === 'narrative' && data?.formName) {
    setRecoil(enhanceNoteLoadingState, (prev) => {
      const index = prev.findIndex((item) => item === data.formName);
      if (index === -1) return prev;

      const newValue = [...prev];
      newValue.splice(index, 1);

      return newValue;
    });
  }
  const aiTimeout = getRecoil(state.intelligenceAiState);
  clearTimeout(aiTimeout?.timeoutTimeout);
  setRecoil(state.intelligenceAiState, (ps) => ({
    ...ps,
    timeoutTimeout: null
  }));
};
